import { useCallback, useState } from "react";

import { CompanyKnowledgeList } from "@/components/company-knowledge/CompanyKnowledgeList";
import { CompanyKnowledgeUploadCard } from "@/components/company-knowledge/CompanyKnowledgeUploadCard";
import { AppCard } from "@/components/ui";

type TCompanyKnowledgeFeatureProps = {
  companyId?: string | null;
  companyName?: string | null;
};

export function CompanyKnowledgeFeature({ companyId, companyName }: TCompanyKnowledgeFeatureProps) {
  const [refetchTrigger, setRefetchTrigger] = useState(0);
  const handleUploadSuccess = useCallback(() => {
    setRefetchTrigger((n) => n + 1);
  }, []);

  return (
    <div className="flex h-full flex-col gap-4">
      {/* Two-column layout: Add Company Knowledge (left) and Company Knowledge List (right) */}
      {companyId && (
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          {/* Add Company Knowledge Section (Left) */}
          <AppCard className="p-4">
            <h3 className="mb-4 text-base font-semibold text-foreground sm:text-lg">Add Company Knowledge</h3>
            <CompanyKnowledgeUploadCard companyId={companyId} onUploadSuccess={handleUploadSuccess} />
            {/* TODO: restore capacity bar once backend provides real usage data */}
          </AppCard>

          {/* Company Knowledge List Section (Right) */}
          <AppCard className="p-4">
            <CompanyKnowledgeList
              companyId={companyId}
              companyName={companyName}
              maxItems={5}
              refetchTrigger={refetchTrigger}
            />
          </AppCard>
        </div>
      )}
    </div>
  );
}
